import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';

interface IBreadcrumb {
    label: string;
    params?: Params;
    url: string;
}

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
    breadcrumbs: Array<IBreadcrumb>;

    constructor(public router: Router, public route: ActivatedRoute) {}

    ngOnInit(): void {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
            // note, we don't use event
            this.breadcrumbs = [];
            let currentRoute = this.route.root;
            let url = '';
            do {
                const childrenRoutes = currentRoute.children;
                currentRoute = undefined;
                childrenRoutes.forEach((route) => {
                    const routeSnapshot = route.snapshot;
                    url += `/${routeSnapshot.url.map((segment) => segment.path).join('/')}`;
                    if (route.snapshot.data['breadcrumb']) {
                        this.breadcrumbs.push({
                            label: route.snapshot.data['breadcrumb'],
                            url
                        });
                    }
                    currentRoute = route;
                });
            } while (currentRoute);
        });
    }

    trackByBreadcrumb(index: number, breadcrumb: IBreadcrumb): number {
        return index;
    }
}
